<template>
<div class="chapter">
<div class="inner_page">
<div class="image">
<p class="center"><img alt="Lovable Confections from the Lone Star State SWEET–ON–TEXAS DENISE GEE PHOTOGRAPHS BY ROBERT M. PEACOCK" src="images/titlepage.jpg" width="100%"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002titlepage.vue?28ad9727